/**
 * clipGuard.js — плоскости отсечения объёма не отдаются камере. [12.0.51]
 *
 * ПОВОД (найдено при проверке вкладки «3D/Кинематика», на стенде с настоящим
 * Cornerstone 5.6.3). Cornerstone считает ПЕРВЫЕ ДВЕ плоскости маппера своими
 * «плоскостями камеры» (Viewport.updateClippingPlanesForActors: «we assume
 * that the first two clipping plane of the mapper are always the 'camera'
 * clipping»). При любом повороте вида или сдвиге фокуса вдоль взгляда он
 * переставляет их в тонкий слой у точки фокуса. А первые две плоскости
 * объёмного окна — это НАШИ «Убрать стол», «Передняя стенка», грани «Окна
 * обзора» (ui/sidebarBindings.js, _применитьОтсечение).
 *
 * Замер: стол + передняя стенка, поворот на 30°/20° — плоскости стали
 * [0,0,±1] у фокуса; «Авто-фрейм» после этого — пустой кадр (0% непустых
 * пикселей). То есть с включённым отсечением поворот мышью, кнопки поворота,
 * «Авто-фрейм» и «Тряска» превращали объём в срез толщиной в доли миллиметра.
 *
 * КАК. Своих «плоскостей камеры» у объёмного окна нет — Cornerstone их не
 * добавляет, он лишь переиспользует первые две, если они есть. Поэтому после
 * его перестановки (событие CLIPPING_PLANES_UPDATED, синхронно, до отрисовки)
 * наши плоскости возвращаются на место — по запомненным числам, в те же
 * объекты, без пересоздания.
 *
 * EXPORTS: запомнитьПлоскости, вернутьПлоскости, стеречьОкно, СОБЫТИЕ
 */

/** Имя события Cornerstone (Enums.Events.CLIPPING_PLANES_UPDATED). */
export const СОБЫТИЕ = 'CORNERSTONE_CLIPPING_PLANES_UPDATED';

const _запомнено = new WeakMap();   // маппер → [{origin, normal}]
const _стерегу = new WeakSet();     // элементы окон, на которых висит слушатель

/** Запомнить плоскости, которые МЫ положили на маппер (пустой список — снять). */
export function запомнитьПлоскости(маппер, список) {
  if (!маппер) return;
  if (!список || !список.length) { _запомнено.delete(маппер); return; }
  _запомнено.set(маппер, список.map((п) => ({ origin: [...п.origin], normal: [...п.normal] })));
}

/**
 * Вернуть запомненные числа в плоскости маппера.
 * @returns {number} сколько плоскостей пришлось поправить
 */
export function вернутьПлоскости(маппер) {
  const наши = маппер && _запомнено.get(маппер);
  if (!наши) return 0;
  const плоскости = маппер.getClippingPlanes?.() || [];
  let поправлено = 0;
  for (let i = 0; i < Math.min(наши.length, плоскости.length); i++) {
    const п = плоскости[i], н = наши[i];
    const o = п.getOrigin?.(), n = п.getNormal?.();
    const сдвинута = !o || !n || o.some((v, к) => v !== н.origin[к]) || n.some((v, к) => v !== н.normal[к]);
    if (сдвинута) { п.setOrigin(...н.origin); п.setNormal(...н.normal); поправлено++; }
  }
  if (поправлено) маппер.modified?.();
  return поправлено;
}

/** Повесить слушатель на окно один раз. */
export function стеречьОкно(элемент, имяСобытия = СОБЫТИЕ) {
  if (!элемент || _стерегу.has(элемент)) return false;
  _стерегу.add(элемент);
  элемент.addEventListener(имяСобытия, (e) => {
    const м = e?.detail?.actorEntry?.actor?.getMapper?.();
    if (м) вернутьПлоскости(м);
  });
  return true;
}
